module.exports = __webpack_public_path__ + "static/10-06d070b84c83c31774a2a1c83cbca1d9.jpg";